module.exports = __webpack_public_path__ + "static/heritage-beds-circle-text-5b868de00790718620b96652cfd9b114.jpg";